// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.createtrip_invalid__7vA7n {
  border: 1px solid red !important;
}

.createtrip_startloc__mbT46 {
  border: 1px solid red !important;
  border-radius: 5px;
}

.createtrip_endloc__4nTNK {
  border: 1px solid red !important;
  border-radius: 5px;
}

.createtrip_clearbtn__0KR1c {
  position: absolute;
  top: 29px;
  right: 40px;
  z-index: 10;
}

.createtrip_clearbtn1__1NG7R {
  position: absolute;
  top: 29px;
  right: 20px;
  z-index: 10;
}

.createtrip_clearbtnSE__583yt {
  position: absolute;
  top: 29px;
  right: 27px;
  z-index: 10;
}

.createtrip_clearbtnstatus__MTvNK {
  position: absolute;
  top: 29px;
  right: 20px;
  z-index: 10;
}

.createtrip_clearbtnsearch__U7v7h {
  position: absolute;
  top: 7px;
  right: 10px;
  z-index: 10;
}

.createtrip_clearbtnsearch1__5CDaL {
  position: absolute;
  top: 7px;
  right: 20px;
  z-index: 10;
}

.createtrip_invalid_input_icon__SYjrk {
  position: absolute;
  top: 30px;
  right: 30px;
  z-index: 10;
}

.createtrip_icon__P6LS1 {
  padding-left: 5px;
  height: 32px;
}

.createtrip_Search__Tbxz8 input {
  padding: 7.8px 15px;
  border: 1px solid #c7c7c7;
  outline: none;
  border-radius: 5px;
}

.createtrip_DragDrop__aTKIE {
  border: 3px dashed #c7c7c7;
  width: 90%;
  margin: 0px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  height: 300px;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
}

.createtrip_DragLayerPartiColor__5Nn5K {
  background-color: rgba(199, 199, 199, 0.15);
  text-align: center;
  font-weight: bolder;
}

.createtrip_form-control__nxwtB:disabled, .createtrip_form-control__nxwtB[readonly] {
  display: none;
}

.createtrip_DragLayerPartiText__mhTqj {
  position: absolute;
  text-align: center;
  font-weight: 500;
  width: 100%;
  top: 45%;
  padding: 0px 10px;
}

.createtrip_DragDrop1__WkDb2 {
  border: 3px dashed #c7c7c7;
  margin: 6px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  aspect-ratio: 4/3;
}

.createtrip_DragDropTrip__q7kv7 {
  border: 3px dashed #c7c7c7;
  width: 90%;
  margin: 0px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  aspect-ratio: 3/2;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
}

.createtrip_Preview__K4B0v {
  width: 100%;
  height: 100%;
  position: absolute;
  object-fit: cover;
  border-radius: 10px;
}

.createtrip_DropInput__Bx9me {
  opacity: 0;
}

.createtrip_DropInput__Bx9me input {
  height: 100vh;
  width: 100vw;
}

.createtrip_DropInput1__h2\\+KP input {
  height: 150px;
  width: 100vw;
}

.createtrip_DragText__kg32A {
  display: flex;
  align-items: center;
  position: absolute;
  font-weight: 500;
  padding: 5px;
  text-align: center;
}

@media (max-width: 767px) {
  .createtrip_Hidden__SeRsl {
    display: none;
  }
}
::-webkit-scrollbar {
  width: 8px;
  background-color: whitesmoke;
  border-radius: 3px;
  height: 8px;
}

::-webkit-scrollbar-thumb:vertical {
  background-color: grey;
  border-radius: 6px;
  border: 2px solid white;
}

::-webkit-scrollbar-thumb:horizontal {
  background-color: grey;
  border-radius: 6px;
  border: 2px solid white;
}

.createtrip_GeoGrandContainer__BJzkO {
  display: flex;
  justify-content: end;
}

.createtrip_GeoItem__w-XCI {
  padding: 10px;
  border-bottom: 1px solid gainsboro;
  margin: 0px;
  background-color: white;
  text-transform: capitalize;
}

.createtrip_GeoItem__w-XCI:hover {
  background-color: whitesmoke;
}

.createtrip_gSection__9J9GK {
  background-color: #1c243b;
  margin: 5px;
  position: relative;
  border-radius: 5px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.createtrip_gClosebtn__N7AUg {
  position: relative;
  right: 20px;
  z-index: 2;
  margin: 3px;
}

.createtrip_gClosebtn1__IhkoA {
  position: absolute;
  right: 80px;
}

.createtrip_gClosebtn2__3zXsK {
  position: absolute;
  right: 67px;
}

.createtrip_gClosebtnJust__CCyNy {
  justify-content: end;
  padding: 5px 13px;
}

.createtrip_gImg__uHCJx {
  padding: 2px;
}

.createtrip_searchGallery__xNUp8 {
  background-color: #ffffff !important;
}

.createtrip_GsearchBtn__JAwhW {
  position: absolute;
  top: 0px;
  margin: 3px;
  right: 0px;
}

.createtrip_ResultNotFound__aZgKd {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.createtrip_ImgCon__RF7d8 {
  padding: 10px;
  overflow: auto;
  margin-top: 10px;
  height: 70vh;
}

.createtrip_ImgGSpinner__bJ7PN {
  display: flex;
  height: 65vh;
  justify-content: center;
  align-items: center;
}

.createtrip_paginationBox__oh6ZK {
  display: flex;
  justify-content: space-around;
  padding: 10px;
  margin-top: 30px;
}

.createtrip_LeftSec__EqNS2 {
  transition: 0.3s ease;
}

.createtrip_GPCloseContainer__1riFH {
  position: absolute;
  transition: 0.4s ease;
  right: -100vw;
  z-index: 2;
}

.createtrip_GPOpenContainer__OIXMt {
  right: 0%;
  position: relative;
  transition: 0.4s ease;
  z-index: 2;
}

.createtrip_gSection__9J9GK {
  background-color: #1c243b;
  margin: 5px;
  position: relative;
  border-radius: 5px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.createtrip_gClosebtn__N7AUg {
  position: relative;
  right: 20px;
  z-index: 2;
  margin: 3px;
}

.createtrip_gClosebtn1__IhkoA {
  position: absolute;
  right: 80px;
}

.createtrip_gClosebtn2__3zXsK {
  position: absolute;
  right: 67px;
}

.createtrip_gClosebtnJust__CCyNy {
  justify-content: end;
  padding: 5px 13px;
}

.createtrip_gImg__uHCJx {
  padding: 2px;
}

.createtrip_searchGallery__xNUp8 {
  background-color: #ffffff !important;
}

.createtrip_GsearchBtn__JAwhW {
  position: absolute;
  top: 0px;
  margin: 3px;
  right: 0px;
}

.createtrip_ResultNotFound__aZgKd {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.createtrip_ImgCon__RF7d8 {
  padding: 10px;
  overflow: auto;
  margin-top: 10px;
  height: 70vh;
}

.createtrip_ImgGSpinner__bJ7PN {
  display: flex;
  height: 65vh;
  justify-content: center;
  align-items: center;
}

.createtrip_paginationBox__oh6ZK {
  display: flex;
  justify-content: space-around;
  padding: 10px;
  margin-top: 30px;
}

.createtrip_LeftSec__EqNS2 {
  transition: 0.3s ease;
}

.createtrip_GPCloseContainer__1riFH {
  position: absolute;
  transition: 0.4s ease;
  right: -100vw;
  z-index: 2;
}

.createtrip_GPOpenContainer__OIXMt {
  right: 0%;
  position: relative;
  transition: 0.4s ease;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/styles/createtrip.module.scss","webpack://./src/styles/globalScroll.module.scss","webpack://./src/styles/ItemsStyle/externalplace.module.scss","webpack://./src/styles/ItemsStyle/galleryplace.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;AACF;;AAEA;EACE,gCAAA;EACA,kBAAA;AACF;;AACA;EACE,gCAAA;EACA,kBAAA;AAEF;;AAAA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AAGF;;AADA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AAIF;;AAFA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AAKF;;AAHA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AAMF;;AAJA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AAOF;;AALA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AAQF;;AANA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AASF;;AAPA;EACE,iBAAA;EACA,YAAA;AAUF;;AAPA;EACE,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;AAUF;;AAPA;EACE,0BAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAUF;;AARA;EACE,2CAAA;EACA,kBAAA;EACA,mBAAA;AAWF;;AARA;EACE,aAAA;AAWF;;AATA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;AAYF;;AAVA;EACE,0BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAaF;;AAXA;EACE,0BAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EAEA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAaF;;AARA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAWF;;AATA;EACE,UAAA;AAYF;;AAVA;EACE,aAAA;EACA,YAAA;AAaF;;AAXA;EACE,aAAA;EACA,YAAA;AAcF;;AAZA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAeF;;AAZA;EACE;IACE,aAAA;EAeF;AACF;AC3KA;EACI,UAAA;EACA,4BAAA;EACA,kBAAA;EACA,WAAA;AD6KJ;;AC3KA;EACI,sBAAA;EACA,kBAAA;EACA,uBAAA;AD8KJ;;AC5KA;EACI,sBAAA;EACA,kBAAA;EACA,uBAAA;AD+KJ;;AE5LA;EACI,aAAA;EACA,oBAAA;AF+LJ;;AElLA;EACI,aAAA;EACA,kCAAA;EACA,WAAA;EACA,uBAAA;EACA,0BAAA;AFqLJ;;AEnLA;EACI,4BAAA;AFsLJ;;AGxMA;EACE,yBAAA;EAEA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,4BAAA;AH0MF;;AGxMA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AH2MF;;AGzMA;EACE,kBAAA;EACA,WAAA;AH4MF;;AG1MA;EACE,kBAAA;EACA,WAAA;AH6MF;;AG3MA;EACE,oBAAA;EACA,iBAAA;AH8MF;;AG5MA;EACE,YAAA;AH+MF;;AG7MA;EAGE,oCAAA;AH8MF;;AG5MA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;AH+MF;;AG7MA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AHgNF;;AG9MA;EACE,aAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AHiNF;;AG/MA;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AHkNF;;AGhNA;EACE,aAAA;EACA,6BAAA;EACA,aAAA;EACA,gBAAA;AHmNF;;AGjNA;EACI,qBAAA;AHoNJ;;AGlNA;EACI,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,UAAA;AHqNJ;;AGlNA;EACI,SAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;AHqNJ;;AGpSA;EACE,yBAAA;EAEA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,4BAAA;AHsSF;;AGpSA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AHuSF;;AGrSA;EACE,kBAAA;EACA,WAAA;AHwSF;;AGtSA;EACE,kBAAA;EACA,WAAA;AHySF;;AGvSA;EACE,oBAAA;EACA,iBAAA;AH0SF;;AGxSA;EACE,YAAA;AH2SF;;AGzSA;EAGE,oCAAA;AH0SF;;AGxSA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;AH2SF;;AGzSA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AH4SF;;AG1SA;EACE,aAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AH6SF;;AG3SA;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AH8SF;;AG5SA;EACE,aAAA;EACA,6BAAA;EACA,aAAA;EACA,gBAAA;AH+SF;;AG7SA;EACI,qBAAA;AHgTJ;;AG9SA;EACI,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,UAAA;AHiTJ;;AG9SA;EACI,SAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;AHiTJ","sourcesContent":[".invalid {\n  border: 1px solid red !important;\n}\n\n.startloc {\n  border: 1px solid red !important;\n  border-radius: 5px;\n}\n.endloc {\n  border: 1px solid red !important;\n  border-radius: 5px;\n}\n.clearbtn {\n  position: absolute;\n  top: 29px;\n  right: 40px;\n  z-index: 10;\n}\n.clearbtn1 {\n  position: absolute;\n  top: 29px;\n  right: 20px;\n  z-index: 10;\n}\n.clearbtnSE {\n  position: absolute;\n  top: 29px;\n  right: 27px;\n  z-index: 10;\n}\n.clearbtnstatus {\n  position: absolute;\n  top: 29px;\n  right: 20px;\n  z-index: 10;\n}\n.clearbtnsearch {\n  position: absolute;\n  top: 7px;\n  right: 10px;\n  z-index: 10;\n}\n.clearbtnsearch1 {\n  position: absolute;\n  top: 7px;\n  right: 20px;\n  z-index: 10;\n}\n.invalid_input_icon {\n  position: absolute;\n  top: 30px;\n  right: 30px;\n  z-index: 10;\n}\n.icon {\n  padding-left: 5px;\n  height: 32px;\n}\n\n.Search input {\n  padding: 7.8px 15px;\n  border: 1px solid rgb(199, 199, 199);\n  outline: none;\n  border-radius: 5px;\n}\n\n.DragDrop {\n  border: 3px dashed rgb(199, 199, 199);\n  width: 90%;\n  margin: 0px auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px;\n  height: 300px;\n  position: relative;\n  overflow: hidden;\n  border-radius: 10px;\n}\n.DragLayerPartiColor {\n  background-color: rgba(199, 199, 199, 0.15);\n  text-align:center;\n  font-weight: bolder;\n\n}\n.form-control:disabled, .form-control[readonly] {\n  display: none; \n}\n.DragLayerPartiText {\n  position: absolute;\n  text-align: center;\n  font-weight: 500;\n  width:100%;\n  top:45%;\n  padding: 0px 10px;\n}\n.DragDrop1 {\n  border: 3px dashed rgb(199, 199, 199);\n  margin: 6px auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  border-radius: 10px;\n  aspect-ratio: 4/3;\n}\n.DragDropTrip {\n  border: 3px dashed rgb(199, 199, 199);\n  width: 90%;\n  margin: 0px auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px;\n  // height: 300px;\n  aspect-ratio: 3/2;\n  position: relative;\n  overflow: hidden;\n  border-radius: 10px;\n}\n// ::-webkit-scrollbar {\n//   display: none;\n// }\n.Preview {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  object-fit: cover;\n  border-radius: 10px;\n}\n.DropInput {\n  opacity: 0;\n}\n.DropInput input {\n  height: 100vh;\n  width: 100vw;\n}\n.DropInput1 input {\n  height: 150px;\n  width: 100vw;\n}\n.DragText {\n  display: flex;\n  align-items: center;\n  position: absolute;\n  font-weight: 500;\n  padding: 5px;\n  text-align: center;\n}\n\n@media (max-width: 767px) {\n  .Hidden {\n    display: none;\n  }\n}\n\n@import './globalScroll.module.scss', './ItemsStyle/externalplace.module.scss','./ItemsStyle//galleryplace.module.scss'","::-webkit-scrollbar {\n    width: 8px;\n    background-color: whitesmoke;\n    border-radius: 3px;\n    height: 8px;\n}\n::-webkit-scrollbar-thumb:vertical {\n    background-color: grey;\n    border-radius: 6px;\n    border: 2px solid white;\n}\n::-webkit-scrollbar-thumb:horizontal {\n    background-color: grey;\n    border-radius: 6px;\n    border: 2px solid white;\n}\n","\n.GeoGrandContainer{\n    display: flex;\n    justify-content: end;\n}\n.GeoContainer {\n    // right: 0;\n    // background-color: white;\n    // max-height: 300px;\n    // overflow: auto;\n    // border: 1px solid gainsboro;\n    // border-radius: 5px;\n    // box-shadow: 0 0 3px #ccc;\n    // margin-bottom: 5px;\n}\n\n.GeoItem {\n    padding: 10px;\n    border-bottom: 1px solid gainsboro;\n    margin: 0px;\n    background-color: white;\n    text-transform: capitalize;\n}\n.GeoItem:hover{\n    background-color: whitesmoke;\n}\n\n@import '../ItemsStyle//galleryplace.module.scss'",".gClose {\n \n}\n.gOpen {\n \n}\n.gSection {\n  background-color: #1c243b;\n  // min-height: 100vh;\n  margin: 5px;\n  position: relative;\n  border-radius: 5px;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n.gClosebtn {\n  position: relative;\n  right: 20px;\n  z-index: 2;\n  margin: 3px;\n}\n.gClosebtn1 {\n  position: absolute;\n  right: 80px;\n}\n.gClosebtn2 {\n  position: absolute;\n  right: 67px;\n}\n.gClosebtnJust {\n  justify-content: end;\n  padding: 5px 13px;\n}\n.gImg {\n  padding: 2px;\n}\n.searchGallery {\n  // top: 0px;\n  // position: absolute;\n  background-color: #ffffff !important;\n}\n.GsearchBtn {\n  position: absolute;\n  top: 0px;\n  margin: 3px;\n  right: 0px;\n}\n.ResultNotFound{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n.ImgCon {\n  padding: 10px;\n  overflow: auto;\n  margin-top: 10px;\n  height: 70vh;\n}\n.ImgGSpinner{\n  display: flex;\n  height: 65vh;\n  justify-content: center;\n  align-items: center;\n}\n.paginationBox{\n  display: flex;\n  justify-content: space-around;\n  padding: 10px;\n  margin-top: 30px;\n}\n.LeftSec{\n    transition: 0.3s ease;\n}\n.GPCloseContainer{\n    position: absolute;\n    transition: 0.4s ease;\n    right: -100vw;\n    z-index: 2;\n}\n\n.GPOpenContainer{\n    right: 0%;\n    position: relative;\n    transition: 0.4s ease;\n    z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"invalid": `createtrip_invalid__7vA7n`,
	"startloc": `createtrip_startloc__mbT46`,
	"endloc": `createtrip_endloc__4nTNK`,
	"clearbtn": `createtrip_clearbtn__0KR1c`,
	"clearbtn1": `createtrip_clearbtn1__1NG7R`,
	"clearbtnSE": `createtrip_clearbtnSE__583yt`,
	"clearbtnstatus": `createtrip_clearbtnstatus__MTvNK`,
	"clearbtnsearch": `createtrip_clearbtnsearch__U7v7h`,
	"clearbtnsearch1": `createtrip_clearbtnsearch1__5CDaL`,
	"invalid_input_icon": `createtrip_invalid_input_icon__SYjrk`,
	"icon": `createtrip_icon__P6LS1`,
	"Search": `createtrip_Search__Tbxz8`,
	"DragDrop": `createtrip_DragDrop__aTKIE`,
	"DragLayerPartiColor": `createtrip_DragLayerPartiColor__5Nn5K`,
	"form-control": `createtrip_form-control__nxwtB`,
	"DragLayerPartiText": `createtrip_DragLayerPartiText__mhTqj`,
	"DragDrop1": `createtrip_DragDrop1__WkDb2`,
	"DragDropTrip": `createtrip_DragDropTrip__q7kv7`,
	"Preview": `createtrip_Preview__K4B0v`,
	"DropInput": `createtrip_DropInput__Bx9me`,
	"DropInput1": `createtrip_DropInput1__h2+KP`,
	"DragText": `createtrip_DragText__kg32A`,
	"Hidden": `createtrip_Hidden__SeRsl`,
	"GeoGrandContainer": `createtrip_GeoGrandContainer__BJzkO`,
	"GeoItem": `createtrip_GeoItem__w-XCI`,
	"gSection": `createtrip_gSection__9J9GK`,
	"gClosebtn": `createtrip_gClosebtn__N7AUg`,
	"gClosebtn1": `createtrip_gClosebtn1__IhkoA`,
	"gClosebtn2": `createtrip_gClosebtn2__3zXsK`,
	"gClosebtnJust": `createtrip_gClosebtnJust__CCyNy`,
	"gImg": `createtrip_gImg__uHCJx`,
	"searchGallery": `createtrip_searchGallery__xNUp8`,
	"GsearchBtn": `createtrip_GsearchBtn__JAwhW`,
	"ResultNotFound": `createtrip_ResultNotFound__aZgKd`,
	"ImgCon": `createtrip_ImgCon__RF7d8`,
	"ImgGSpinner": `createtrip_ImgGSpinner__bJ7PN`,
	"paginationBox": `createtrip_paginationBox__oh6ZK`,
	"LeftSec": `createtrip_LeftSec__EqNS2`,
	"GPCloseContainer": `createtrip_GPCloseContainer__1riFH`,
	"GPOpenContainer": `createtrip_GPOpenContainer__OIXMt`
};
export default ___CSS_LOADER_EXPORT___;
